module.exports = __webpack_public_path__ + "b0d81596a3e7194c4484a63f9f5a293c.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/chevron-right.svg
// module id = 9OQQ
// module chunks = 0